import { useCallback } from 'react';
import { pruneNilValues } from '@core/object';
import { sendPixelTrackingWithSession } from '@core/tracking';
import { useEmbedFeedStoreApi } from '@core/widgets/embedFeed/store';
import { useStoreApi } from '@core/widgets/store';
import { FEED_SCROLL_VIDEOS } from '@core/widgets/tracking/endpoints';
import { sortByOtherArray } from '@embed/tools/utils';
import { useTracking } from './useTracking';
/**
 * Hook to return callback which should be triggered on scroll
 * events of embed feed (throttled) to track thumbnails being
 * scrolled by. Each thumbnail is tracked only once.
 */
export const useTrackEmbedScrollVideos = () => {
    const { params, pixelTrackingData } = useTracking();
    const storeApi = useStoreApi();
    const embedFeedStoreApi = useEmbedFeedStoreApi();
    return useCallback(() => {
        const { inViewportIdsReportQueue, inViewportIdsReportSuccess, actions: { processInViewportQueue }, } = embedFeedStoreApi.getState();
        const alreadyProcessed = new Set(inViewportIdsReportSuccess);
        const notYetProcessed = [
            ...new Set(inViewportIdsReportQueue),
        ].filter((x) => !alreadyProcessed.has(x));
        if (notYetProcessed.length === 0) {
            return;
        }
        processInViewportQueue(notYetProcessed);
        const navigation = storeApi.getState().navigation;
        const ids = sortByOtherArray(notYetProcessed, navigation);
        const pixelData = {
            event_properties: pruneNilValues({
                ...pixelTrackingData,
                ui_player_style: params?.ui_player_style,
                ui_theme: params?.theme || params?.ui_theme,
                _viewport_videos_ids: ids,
            }),
        };
        sendPixelTrackingWithSession({
            endpoint: FEED_SCROLL_VIDEOS,
            data: pixelData,
            host: params.api_host_tracking,
        });
    }, [embedFeedStoreApi, params, pixelTrackingData, storeApi]);
};
